const Baobab = require('baobab')

const storage = new Baobab({
  common: {},
  serverProps: {},
}, {
  asynchronous: false,
})

module.exports = storage
